<div id="container-login">

    <mat-card id="card-login">
      <mat-card-header>
        <div fxLayout="row">
          <div fxFlex="300px">
            <h3>Acesso Administrativo</h3>
          </div>
        </div>
      </mat-card-header>
  
      <mat-divider></mat-divider>
  
      <mat-card-content>

        <form [formGroup]="form"  class="formulario">
 
          <div fxLayout.align="center" fxLayout.xs="column" fxLayoutGap="20px">
  

            <mat-form-field >
                <mat-label>Código de Acesso:</mat-label>
                <input matInput type="password" formControlName="cpf" mask="000.000.000-99" >
            </mat-form-field>

            </div>

            <p>
            <p>                
            <p>
            <p>
            <p>
            <p>
            <div fxLayout.align="center" fxLayout.xs="column" fxLayoutGap="20px">
                <button mat-raised-button name="envia" color="primary" (click)="validaAcesso()" >
                    Enviar
                </button>

                <button mat-raised-button name="volta" color="primary" (click)="voltaAcesso()" >
                    Voltar
                </button>

            </div>
        </form>
  
   
      </mat-card-content>
  
    </mat-card>
  
  </div>
  
